import React from 'react'
import './leaderboard.css'

const leaderboardData = [
	{
		rank: 1,
		trader: '@whalehunter',
		value: '$24,000',
		roi: '62%',
		fee: '$340',
	},
	{ rank: 2, trader: '@defichad', value: '$19,550', roi: '48%', fee: '$150' },
	{
		rank: 3,
		trader: '@yieldfarmer',
		value: '$18,200',
		roi: '42%',
		fee: '$120',
	},
	{
		rank: 4,
		trader: '@cryptoking',
		value: '$15,600',
		roi: '36%',
		fee: '$85',
	},
	{
		rank: 5,
		trader: '@aaveaddict',
		value: '$12,400',
		roi: '28%',
		fee: '$60',
	},
]

const getMedal = (rank: any) => {
	if (rank === 1) return '🏆'
	if (rank === 2) return '🥈'
	if (rank === 3) return '🥉'
	return ''
}

const Leaderboard = () => {
	return (
		<div className="leaderboard-wrapper">
			<h2>Leaderboard</h2>
			<div className="table">
				<div className="table-header">
					<div>Rank ⬍</div>
					<div>Trader</div>
					<div>Account Value ⬍</div>
					<div>
						ROI ⬍ <span className="info-icon">?</span>
					</div>
					<div>
						Referral Fee ⬍ <span className="info-icon">?</span>
					</div>
				</div>
				{leaderboardData.map((row) => (
					<div className="table-row" key={row.rank}>
						<div>
							{getMedal(row.rank)} {row.rank}
						</div>
						<div>{row.trader}</div>
						<div>{row.value}</div>
						<div className="positive">{row.roi}</div>
						<div>{row.fee}</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default Leaderboard
